import { createSvgComponent } from "../../icon/createSvgComponent";
import Orders from "@core/icon/assets/orders.svg";
export default createSvgComponent(Orders);